import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { Destination } from 'src/app/core/types/models/destination.model';
import { CityResponse } from 'src/app/core/types/models/city-response.model';

import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';

import { CountryInfoService } from 'src/app/core/services/country-info.service';

@Component({
  selector: 'app-city-card-mobile',
  templateUrl: './city-card-mobile.component.html',
  styleUrls: ['city-card-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, SafeUrlPipe, NgxSkeletonLoaderModule],
})
export class CityCardMobileComponent {
  @Input() city: Destination | null = null;
  @Input() countryName: string = '';
  @Input() regionName: string = '';
  @Input() isFetching: boolean = false;
  @Input() cityResponse: CityResponse;

  public getThingsTodoLink(name: string): string {
    return `/things-to-do-in-${name.toLowerCase()}`;
  }
}
